import { RID } from '@sharefiledev/sfplugin-resource-id';
import { RequestListEntityType } from '../types';

export function getRequestListRID(resourceId: string) {
	const rid = RID.parse(resourceId);
	const requestListRID = rid.findEntityType(RequestListEntityType.requestlist);
	if (!requestListRID) {
		throw new Error(`No request list resource found for: ${resourceId}`);
	}
	return requestListRID;
}
